import { createContext } from "react";

/** True when an ancestor already owns the outer page inset, including canvases. */
export const PageSpacingContext = createContext(false);
